import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        benefitStack: {
            align: 'stretch',
            gap: remCalc(10),
        },
        icon: {
            boxSize: 'iconsSize.small',
            color: 'background.dark',
        },
    },
    parts: ['icon'],
}
